/* eslint-disable import/prefer-default-export */
import appStore from 'client/AppStore';
import {resource} from '@albert-io/json-api-framework/request/builder';
import masqueradeStore from 'client/generic/Masquerade/Masquerade.store';

export function getClassroomsForTeacherClassroomsDashboardQuery({page} = {page: 1}) {
  const isArchivedPage = appStore.routerProps.location.pathname.includes('/archived');
  return resource('classrooms_v1')
    .mandarkEndpoint(['teachers_v1', masqueradeStore.getUserIdByMasqueradeState(), 'classrooms_v1'])
    .include('school_v5.email_domains_v1,students_v2')
    .include('classroom_invitations_v1', !isArchivedPage)
    .include('grade_levels_v1')
    .withMeta('classroom_v1')
    .customQuery({
      meta: {
        context: {
          school: {
            school_license_seats_remaining: true
          }
        }
      }
    })
    .filter(
      {
        status: 'active'
      },
      !isArchivedPage
    )
    .filter(
      {
        status: 'archived'
      },
      isArchivedPage
    )
    .filter(
      {
        included: {
          classroom_invitations_v1: {
            accepted_at: {
              null: true
            }
          }
        }
      },
      !isArchivedPage
    )
    .filter({
      school_v5: masqueradeStore.getSchoolId()
    })
    .sort('name')
    .pageSize(6)
    .page(page);
}
